import React from "react";
import { useTranslation } from "react-i18next";

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  required?: boolean;
  className?: string;
}

const TermsCheckbox: React.FC<TermsCheckboxProps> = ({
  checked,
  onChange,
  required = true,
  className = ""
}) => {
  const { t } = useTranslation();

  const openDatenschutz = () => {
    window.open("/datenschutz", "_blank");
  };

  return (
    <div className={`flex items-start gap-3 ${className}`}>
      <input
        type="checkbox"
        id="terms-checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required={required}
        className="mt-1 w-4 h-4 accent-[#D8001D] text-[#D8001D] bg-gray-100 border-gray-300 rounded focus:ring-[#D8001D] focus:ring-2"
      />
      <label htmlFor="terms-checkbox" className="text-sm text-gray-300 leading-relaxed">
        {t("terms.prefix")}
        {t("terms.prefix") ? " " : ""}
        <button
          type="button"
          onClick={openDatenschutz}
          className="text-brand-red-text hover:text-[#B8001A] underline transition-colors cursor-pointer"
        >
          {t("terms.datenschutz")}
        </button>
        {" "}{t("terms.and")}{" "}
        <button
          type="button"
          onClick={openDatenschutz}
          className="text-brand-red-text hover:text-[#B8001A] underline transition-colors cursor-pointer"
        >
          {t("terms.terms")}
        </button>
        {t("terms.suffix")}
        {required && <span className="text-brand-red-text ml-1">*</span>}
      </label>
    </div>
  );
};

export default TermsCheckbox;
